package com.rainbowclubs.rainbow.data.responses

import com.rainbowclubs.rainbow.data.models.Club
import com.rainbowclubs.rainbow.data.models.Membership
import kotlinx.serialization.Serializable

@Serializable
data class SelectClubResponse(
    val memberships: List<Membership> = emptyList(),
    val clubs: List<Club> = emptyList(),
) {
    companion object {
        fun from(
            memberships: List<Membership>,
            clubs: List<Club>,
        ): SelectClubResponse {
            return if (memberships.isNotEmpty()) {
                SelectClubResponse(memberships = memberships, clubs = emptyList())
            } else {
                SelectClubResponse(memberships = emptyList(), clubs = clubs)
            }
        }
    }
}
